var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import CloseIcon from '@mui/icons-material/Close';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Box, IconButton } from '@mui/material';
import React from 'react';
import { MenuIconButton } from '../MenuIconButton';
import { useCommonWebTranslation } from '../hooks';
/**
 * Default top bar actions for a modal slideout.
 *
 * @param {ModalSlideoutTopBarDefaultActionsProps} root0 - Component props.
 * @param {() => void} root0.onClose - Handler to close the slideout.
 * @param {{ label: string; href?: string; onClick?: () => void; disabled?: boolean; 'data-test'?: string; 'aria-label'?: string }[]} [root0.menuItems] - Optional list of menu items for the overflow menu.
 * @returns {JSX.Element} A component rendering a close button and optional menu button.
 */
export const ModalSlideoutTopBarDefaultActions = (_a) => {
    var { onClose, menuItems } = _a, props = __rest(_a, ["onClose", "menuItems"]);
    const { t } = useCommonWebTranslation();
    return (React.createElement(Box, { sx: {
            p: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        }, "data-test": props['data-test'] },
        React.createElement(IconButton, { onClick: onClose, color: 'inherit', "data-test": 'slideout-close-button', "aria-label": t('slideout.close') },
            React.createElement(CloseIcon, null)),
        (menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) ? (React.createElement(MenuIconButton, { menuItems: menuItems, "aria-label": t('common.more') },
            React.createElement(MoreHorizIcon, { "data-test": 'more-button' }))) : null));
};
